import React from 'react';

const ServiceSchema = ({ serviceName }) => {
  const serviceData = {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": serviceName,
    "provider": {
      "@type": "Organization",
      "name": "Belle Epoque",
      "url": "https://belle-epoque.pt"
    },
    "areaServed": {
      "@type": "Place",
      "name": "Global"
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(serviceData) }}
    />
  );
};

export default ServiceSchema;
